module.exports = __webpack_public_path__ + "static/img/matrix.65a156e2.png";